import { useQuery } from "@tanstack/react-query";

import { apiEcmsHttp } from "@services/http";
import { QUERY_KEYS } from "@services/keys";

import type {
  GetChildEntityBillingAccountAuxiliaryBalance,
  GetChildEntityBillingAccountBalanceParams,
} from "./apiEcms.types";

const getChildEntityBillingAccountAuxiliaryBalance = async (
  { customerId, contractId }: GetChildEntityBillingAccountBalanceParams,
  signal: AbortSignal,
) => {
  const { data } =
    await apiEcmsHttp.get<GetChildEntityBillingAccountAuxiliaryBalance>(
      `/child-entities/${customerId}/billing-accounts/${contractId}/auxiliary-balance`,
      { signal },
    );

  return data;
};

export const useGetChildEntityBillingAccountAuxiliaryBalance = ({
  customerId,
  contractId,
}: GetChildEntityBillingAccountBalanceParams) =>
  useQuery({
    queryKey: [QUERY_KEYS.AUXILIARY_BALANCE, customerId, contractId],
    queryFn: ({ signal }) =>
      getChildEntityBillingAccountAuxiliaryBalance(
        { customerId, contractId },
        signal,
      ),
  });
